<template>
  <div>
    <div class="wrapper close_box" style="height: 100vh;">
      <div class="main">
        <div class="box">
          <div class="img_box">
            <img src="/img/logo20251.svg" alt="">
          </div>
          <div class="text">
            <p>
              外交部2025年「國際青年大使交流計畫」報名已截止。
            </p>
            <p>
              本年度錄取名單及相關資訊將公布於 <a href="https://taiwanngo.tw/" title="外交部NGO雙語網站">外交部NGO雙語網站</a>，敬請關注。
              <br>
              感謝您的參與與支持！
            </p>
          </div>
        </div>
      </div>
    </div><!-- wrapper -->
  </div>
</template>
<script>
import FooterBlock from "@/components/FooterBlock.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
  },
  en: {
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Close",
  i18n,
  components: {
    FooterBlock,
    Slick,
  },
  data() {
    return {
      CloseData: {},
      local: "zh_tw",
    };
  },
  created: function () {
  },
  mounted: function () {
    if ($cookies.isKey("gya_main_lang")) {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = $cookies.get("gya_main_lang");
    } else {
      i18n.locale = $cookies.get("gya_main_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
  },
};
</script>
